import Pure from './pure.vue';
import MobPure from './mob-pure.vue';

export const componentMap = {
	pure: Pure,
	'mob-pure': MobPure
};
